import axios from "axios";

import { getConfig } from "~/config";

export type LogoutSessionRequest = {
  refreshToken: string;
  accessToken: string;
};

const endpointUrl = (): string =>
  new URL(
    "api/kontax/accounts/api/sessions",
    getConfig("VITE_APP_API_URL")
  ).toString();

/**
 * Best-effort session revocation. Logout must always clear local state,
 * so this function never throws — network errors and upstream 4xx/5xx
 * responses are swallowed. The upstream is idempotent (204 even for an
 * unknown refresh token), so retries are not required.
 */
export const logoutSession = async (
  request: LogoutSessionRequest
): Promise<void> => {
  try {
    await axios.delete(endpointUrl(), {
      data: { refreshToken: request.refreshToken },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${request.accessToken}`,
      },
      validateStatus: (status) => status === 204 || status === 200,
    });
  } catch {
    // intentional: logout proceeds regardless of upstream errors.
  }
};
